import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=43daad15&"
import script from "./Threads.vue?vue&type=script&lang=js&"
export * from "./Threads.vue?vue&type=script&lang=js&"
import style0 from "./Threads.vue?vue&type=style&index=0&id=43daad15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports